import { render, staticRenderFns } from "./oirp-banner.vue?vue&type=template&id=1d554df5&"
import script from "./oirp-banner.vue?vue&type=script&lang=js&"
export * from "./oirp-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports